import { twMerge } from 'tailwind-merge';

type AnalyticsTableRowProps = {
  text: string;
  width?: string;
};

export const AnalyticsTableRow = ({ text, width }: AnalyticsTableRowProps) => {
  return (
    <div
      className={twMerge(
        'tw-flex tw-h-full tw-items-center tw-justify-center tw-break-words tw-text-center tw-font-jost tw-text-[12px] tw-leading-tight tw-text-white',
        width || 'tw-flex-1'
      )}
    >
      {text}
    </div>
  );
};
